var $url = {
	decodeQ: function(qStr) {
		if (!qStr) return;
	    var q = {};
	    qStr.replace(/;?([^;:]+):([^;]*)/gi, function(m,key,value) {
	        q[key] = key == 'dsts' ? decodeURIComponent(value) : value;
	    });
	    return q;
	},
	encodeQ: function(objQ) {
		return Object.keys(objQ)
			.map(function(k) { return k + ':' + (k == 'dsts' ? encodeURIComponent(objQ[k]) : objQ[k]);}).join(';');
	},
	getVars: function(url) {
	    var vars = {};
	    url = url ? url : window.location.search;
	    url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
	        vars[key] = value;
	    });
		return vars;		
	},
	getVar: function(name, url) {
	    var vars = $url.getVars(url);
	    return vars[name];
	},
	encodeVar: function(paramObj, config) {
		config = config || {};
		paramObj = paramObj || {};
		if (config.url) {
			var urlParams = $url.getVars(config.url);
			for (var param in urlParams) {
				if (urlParams.hasOwnProperty(param) && !paramObj[param]) {
					paramObj[param] = urlParams[param];
				}
			}
			config.url = Object.keys(urlParams).length ? config.url.substr(0, config.url.indexOf('?')) : config.url;
		}
		var paramStr = Object.keys(paramObj)
			.map(function(k) { return k + '=' + (config.uriEncode ? encodeURIComponent(paramObj[k]) : paramObj[k]);}).join('&');
		var str = config.url ? config.url : '';
		str += (config.url && paramStr) ? '?' : '';
		return str + paramStr + (config.hash ? '#' + config.hash : '');
	},
	decodeRmcnf: function(strRooms) {
		if (!strRooms) return;
		var rooms = [];
		strRooms = decodeURI(strRooms);
		strRooms.replace(/\[([0-9]+),([0-9]+)\(?([0-9,]*)\)?\]/gi, function(m, adults, children, childAgesStr) {
			rooms.push({
				adults: parseInt(adults),
				children: parseInt(children),
				childAges: childAgesStr ? childAgesStr.split(',') : null
			});
		});
		return rooms.length ? rooms : undefined;
	},
	encodeRmcnf: function(rooms) {
		if (!rooms) return;
		var roomsObj = [];
		for (var room = 0; room < rooms.length; room++) {
			roomsObj.push('['+ rooms[room].adults + ',' + rooms[room].children + 
			(parseInt(rooms[room].children) ? ( '(' + rooms[room].childAges.join() + ')' ) : '') + ']');
		}
		return rooms.length + roomsObj.join(',');
	}

};
